export default "__VITE_ASSET__CvUQfc4Y__"